module.exports = __webpack_public_path__ + "static/img/lv.72139357.png";